import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AuditLog } from '../../../../models/auditLog';
import { ChangeRow, parseAuditChanges } from '../../../../utilities/auditLogChanges';

@Component({
  selector: 'app-audit-log-changes-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatTableModule],
  templateUrl: './audit-log-changes-dialog.component.html',
  styleUrl: './audit-log-changes-dialog.component.scss'
})
export class AuditLogChangesDialogComponent {
  readonly entry: AuditLog;
  readonly rows: ChangeRow[];
  /** Set when the changes JSON could not be parsed; raw text is shown instead. */
  readonly parseError: boolean;
  readonly rawChanges: string;
  readonly displayedColumns = ['field', 'old', 'new'];

  constructor(
    public dialogRef: MatDialogRef<AuditLogChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: AuditLog
  ) {
    this.entry = data;
    this.rawChanges = data?.changes ?? '';

    const parsed = parseAuditChanges(this.rawChanges);
    this.rows = parsed.rows;
    this.parseError = parsed.parseError;
  }

  close(): void {
    this.dialogRef.close();
  }
}
